// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUpComponent_signUpContainer__1SMG3","signInLinkContainer":"SignUpComponent_signInLinkContainer__3rFsJ"};